import CheckInStats from './CheckInStats';

export default CheckInStats;
